/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * DSV Public API
 * DSV Public API
 * OpenAPI spec version: 1.5.2
 */
import type {
  Event,
  EventId,
  EventRegistrationForm,
  EventRegistrationOptionAvailability,
  EventRegistrationRequest,
  EventRegistrationResponse,
  EventRegistrationSession,
  EventRegistrationSessionId,
  EventRegistrationSessionSelectionRequest,
  Feedback,
  GetEventRegistrationFormParams,
  GetSermonScheduleParams,
  GetSpecialDayNotificationCalendarHeaders,
  GetSpecialDayNotificationCalendarParams,
  GetSpecialOfferingsParams,
  MasterDataBillingCountry,
  SermonSchedule,
  SpecialDayNotificationId,
  SpecialOffering,
  StreamRegistrationAvailabilityParams
} from './model';

import { dsvApiAxiosInstance } from '../../../dsv-api-axios-instance';



  /**
 * @summary Get event
 */
export const getEvent = (
    eventId: EventId,
 ) => {
      return dsvApiAxiosInstance<Event>(
      {url: `/public/api/events/${eventId}`, method: 'GET'
    },
      );
    }
  
/**
 * @summary Get registration form
 */
export const getEventRegistrationForm = (
    eventId: EventId,
    params?: GetEventRegistrationFormParams,
 ) => {
      return dsvApiAxiosInstance<EventRegistrationForm>(
      {url: `/public/api/events/${eventId}/registration/form`, method: 'GET',
        params
    },
      );
    }
  
/**
 * Creates a short-lived session (TTL ~15 minutes) that can hold provisional
reservations for pricing options with limited capacity. Returns the current
remaining capacity for all options so the client can render availability
immediately without a separate request.

 * @summary Start a registration session
 */
export const startRegistrationSession = (
    eventId: EventId,
 ) => {
      return dsvApiAxiosInstance<EventRegistrationSession>(
      {url: `/public/api/events/${eventId}/registration/sessions`, method: 'POST'
    },
      );
    }
  
/**
 * Explicitly releases all reservations held by the session. Clients should
call this when the user navigates away from the registration form. Sessions
are also released automatically on TTL expiry.

 * @summary Release a registration session
 */
export const releaseRegistrationSession = (
    eventId: EventId,
    sessionId: EventRegistrationSessionId,
 ) => {
      return dsvApiAxiosInstance<void>(
      {url: `/public/api/events/${eventId}/registration/sessions/${sessionId}`, method: 'DELETE'
    },
      );
    }
  
/**
 * Replaces the session's current option reservation with the new selection.
The server atomically releases the previous reservation and reserves the new
one. Returns updated remaining capacity for all options.

 * @summary Update selected pricing options for a session
 */
export const updateRegistrationSession = (
    eventId: EventId,
    sessionId: EventRegistrationSessionId,
    eventRegistrationSessionSelectionRequest: EventRegistrationSessionSelectionRequest,
 ) => {
      return dsvApiAxiosInstance<EventRegistrationSession>(
      {url: `/public/api/events/${eventId}/registration/sessions/${sessionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/vnd.dsv.event-registration-session.v1+json;charset=utf-8', },
      data: eventRegistrationSessionSelectionRequest
    },
      );
    }
  
/**
 * Server-Sent Events stream. Pushes an updated EventRegistrationOptionAvailability
list whenever the remaining capacity of any pricing option changes (due to a
confirmed booking, a new reservation, or an expired session releasing capacity).
Clients should subscribe after opening the registration form and use the events
to keep the UI in sync without polling.

 * @summary Stream real-time pricing option availability
 */
export const streamRegistrationAvailability = (
    eventId: EventId,
    params?: StreamRegistrationAvailabilityParams,
 ) => {
      return dsvApiAxiosInstance<EventRegistrationOptionAvailability[]>(
      {url: `/public/api/events/${eventId}/registration/availability`, method: 'GET',
        params
    },
      );
    }
  
/**
 * @summary Save event registration
 */
export const saveEventRegistration = (
    eventId: EventId,
    eventRegistrationRequest: EventRegistrationRequest,
 ) => {
      return dsvApiAxiosInstance<EventRegistrationResponse>(
      {url: `/public/api/events/${eventId}/registrations`, method: 'POST',
      headers: {'Content-Type': 'application/vnd.dsv.event-registration.v1+json;charset=utf-8', },
      data: eventRegistrationRequest
    },
      );
    }
  
/**
 * @summary Send feedback
 */
export const sendFeedback = (
    feedback: Feedback,
 ) => {
      return dsvApiAxiosInstance<void>(
      {url: `/public/api/feedback`, method: 'POST',
      headers: {'Content-Type': 'application/vnd.dsv.feedback.v1+json;charset=utf-8', },
      data: feedback
    },
      );
    }
  
/**
 * @summary Get billing countries
 */
export const getBillingCountries = (
    
 ) => {
      return dsvApiAxiosInstance<MasterDataBillingCountry[]>(
      {url: `/public/api/master-data/billing-countries`, method: 'GET'
    },
      );
    }
  
/**
 * @summary Returns a sermon schedule for a given year and month
 */
export const getSermonSchedule = (
    params: GetSermonScheduleParams,
 ) => {
      return dsvApiAxiosInstance<SermonSchedule>(
      {url: `/public/api/sermon-schedule`, method: 'GET',
        params
    },
      );
    }
  
/**
 * @summary Returns a calendar with all special day notifications for the next 2 years
 */
export const getSpecialDayNotificationCalendar = (
    specialDayNotificationId: SpecialDayNotificationId,
    params?: GetSpecialDayNotificationCalendarParams,
    headers?: GetSpecialDayNotificationCalendarHeaders,
 ) => {
      return dsvApiAxiosInstance<Blob>(
      {url: `/public/api/special-day-notifications/${specialDayNotificationId}.ics`, method: 'GET',
      headers,
        params,
        responseType: 'blob'
    },
      );
    }
  
/**
 * @summary List all special offerings
 */
export const getSpecialOfferings = (
    params: GetSpecialOfferingsParams,
 ) => {
      return dsvApiAxiosInstance<SpecialOffering[]>(
      {url: `/public/api/special-offerings`, method: 'GET',
        params
    },
      );
    }
  

type AwaitedInput<T> = PromiseLike<T> | T;

    type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export type GetEventResult = NonNullable<Awaited<ReturnType<typeof getEvent>>>
export type GetEventRegistrationFormResult = NonNullable<Awaited<ReturnType<typeof getEventRegistrationForm>>>
export type StartRegistrationSessionResult = NonNullable<Awaited<ReturnType<typeof startRegistrationSession>>>
export type ReleaseRegistrationSessionResult = NonNullable<Awaited<ReturnType<typeof releaseRegistrationSession>>>
export type UpdateRegistrationSessionResult = NonNullable<Awaited<ReturnType<typeof updateRegistrationSession>>>
export type StreamRegistrationAvailabilityResult = NonNullable<Awaited<ReturnType<typeof streamRegistrationAvailability>>>
export type SaveEventRegistrationResult = NonNullable<Awaited<ReturnType<typeof saveEventRegistration>>>
export type SendFeedbackResult = NonNullable<Awaited<ReturnType<typeof sendFeedback>>>
export type GetBillingCountriesResult = NonNullable<Awaited<ReturnType<typeof getBillingCountries>>>
export type GetSermonScheduleResult = NonNullable<Awaited<ReturnType<typeof getSermonSchedule>>>
export type GetSpecialDayNotificationCalendarResult = NonNullable<Awaited<ReturnType<typeof getSpecialDayNotificationCalendar>>>
export type GetSpecialOfferingsResult = NonNullable<Awaited<ReturnType<typeof getSpecialOfferings>>>
